import { useCartIdContext } from './CartIdContext'

export function useSetCartId() {
  const cartIdContext = useCartIdContext()

  return (id: string | undefined) => cartIdContext(id)
}
